const styles = theme => ({
  root: {
    display: 'flex',
    width: '100%',
    color: theme.palette.grey[900]
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    width: '100%'
  },
  titleContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    ...theme.typography.body2
  },
  description: {
    ...theme.typography.caption,
    color: theme.palette.grey[600]
  },
  defaultIcon: props => ({
    borderRadius: 4,
    width: 37,
    height: 37,
    marginRight: theme.spacing(2),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: props.iconColor || theme.palette.primary.dark,
    color: theme.palette.common.white,
    ...theme.typography.caption
  })
});

export default styles;
